import { Directive, Input, TemplateRef } from "@angular/core";

@Directive({
    selector: "[gridColumnTemplate]",
})
export class GridColumnTemplateDirective {
    @Input() gridColumnTemplate: string;
    @Input() columnName: string;

    constructor(public template: TemplateRef<any>) {}
}